import { styled, media } from '@nx-kit/styling';
import { DatePicker } from 'components/molecules/DatePicker';
import { BgMotivStyled } from 'components/atoms/PageBackground/PageBackground';
import Column from 'components/layout/Grid/Column';
import { Heading } from 'components/atoms/Heading';
import { SortGroupStyled } from 'components/molecules/FilterRows';

export const HeadingStyled = styled(Heading)`
  margin-bottom: 12px;
`;

export const DateStyled = styled.div`
  color: ${({ theme }) => theme.global.color.primary};
  font-weight: 400;
  line-height: 42px;
  font-size: 32px;

  ${media('md')} {
    font-size: 32px;
    line-height: 42px;
  }

  ${media('lg')} {
    font-size: 46px;
    line-height: 56px;
  }
`;

export const BgMotivTagesplanStyled = styled(BgMotivStyled)`
  img {
    margin-right: -80px;
    width: 2100px;
    height: 950px;
    opacity: 0.25;
    top: -60px;
  }
  display: none;

  ${media('md')} {
    display: block;
  }
`;

export const RowDateSelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 30px;
  width: 100%;

  ${media('md')} {
    flex-direction: row;
    align-items: center;
  }
`;

export const RowDownloadStyled = styled.div`
  margin: 30px 0 40px;
  display: inline-flex !important;
  width: max-content !important;
  max-width: max-content !important;
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
  align-self: flex-start;
  background: transparent;
  &:hover {
    background: transparent;
  }

  & > * {
    flex: 0 0 auto;
    width: max-content !important;
    max-width: max-content !important;
    height: auto !important;
  }
`;

export const RowLoadingStyled = styled.div`
  margin: 30px 0;
`;

export const DatePickerStyled = styled(DatePicker)`
  margin-top: 10px;
  width: 100%;

  ${media('md')} {
    margin-left: 26px;
    margin-top: 6px;
    width: auto;
  }
`;

export const ColumnStyled = styled(Column)`
  position: relative;
`;

export const SortGroup = styled(SortGroupStyled)`
  margin-top: 0;
  margin-bottom: 0;
  ${media('md')} {
    margin-left: auto;
  }
`;

export const FilterControlsRowStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin: 8px 0 30px;

  ${media('md')} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const CategoryFilterRowStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 50px;
`;

export const CategoryButtonStyled = styled.button<{ isActive?: boolean }>`
  padding: 8px 18px;
  border: 1px solid ${({ isActive, theme }) => (isActive ? theme.global.color.primary : '#c8c8c8')};
  border-radius: 6px;
  background: ${({ isActive, theme }) => (isActive ? theme.global.color.primary : '#f5f5f5')};
  color: ${({ isActive }) => (isActive ? '#ffffff' : '#4a4a4a')};
  font-family: DIN, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background: ${({ theme }) => theme.global.color.primary};
    border-color: ${({ theme }) => theme.global.color.primary};
    color: #ffffff;
  }
`;
